import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ControlCashProvider } from "./store/controlCashStore";
import { ToastProvider } from "./contexts/ToastContext";
import { ConfirmProvider } from "./contexts/ConfirmContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import MonthDetail from "./pages/MonthDetail";
import AddEditExpense from "./pages/AddEditExpense";
import RecurringExpenses from "./pages/RecurringExpenses";
import RecurringIncomes from "./pages/RecurringIncomes";
import NewMonth from "./pages/NewMonth";
import EditMonth from "./pages/EditMonth";
import SavingsGoals from "./pages/SavingsGoals";
import UserSettings from "./pages/UserSettings";
import CurrencyConversion from "./pages/CurrencyConversion";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const AuthRedirect = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent" />
      </div>
    );
  }
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
};

const AppWithStore = () => {
  const { user } = useAuth();
  return (
    <ControlCashProvider key={user?.id} userId={user?.id}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/month/new" element={<NewMonth />} />
        <Route path="/month/:id" element={<MonthDetail />} />
        <Route path="/month/:id/edit" element={<EditMonth />} />
        <Route path="/expense/add" element={<AddEditExpense />} />
        <Route path="/expense/edit/:id" element={<AddEditExpense isEditMode={true} />} />
        <Route path="/recurring" element={<RecurringExpenses />} />
        <Route path="/recurring-incomes" element={<RecurringIncomes />} />
        <Route path="/savings" element={<SavingsGoals />} />
        <Route path="/settings" element={<UserSettings />} />
        <Route path="/conversion/add" element={<CurrencyConversion />} />
        <Route path="/conversion/edit/:id" element={<CurrencyConversion />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ControlCashProvider>
  );
};

const AppRoutes = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ToastProvider>
          <ConfirmProvider>
            <Router>
            <Routes>
              <Route
                path="/login"
                element={
                  <AuthRedirect>
                    <Login />
                  </AuthRedirect>
                }
              />
              <Route
                path="/register"
                element={
                  <AuthRedirect>
                    <Register />
                  </AuthRedirect>
                }
              />
              <Route path="/forgot-password" element={<AuthRedirect><ForgotPassword /></AuthRedirect>} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <AppWithStore />
                  </ProtectedRoute>
                }
              />
            </Routes>
            </Router>
          </ConfirmProvider>
        </ToastProvider>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default AppRoutes;
